import React from "react";
import { defineMessages } from "react-intl";
import { Box } from "@mui/material";
import "../../icons/Icon.js";
import { CustomIcon } from "../../icons/types.js";
import "../../icons/ExpandMoreIcon.js";
import "../../input/validation.js";
import "../../input/DatePicker.js";
import "../../input/DateRangePicker.js";
import "../../input/StyledInput.js";
import { FormSelect } from "../../input/FormInput.js";
import "../../input/StyledFormInputHoc.js";
import "moment-timezone";
import "../../input/DateSinglePicker.localize.js";
import "../../input/hooks.js";
import "../../label/EmptyLabel.js";
import { withLabel } from "../../label/LabelHoc.js";
const localized = defineMessages({
  less: {
    id: "ValueRangeFilter_isLessThan",
    defaultMessage: "is less than"
  },
  greater: {
    id: "ValueRangeFilter_isGreaterThan",
    defaultMessage: "is greater than"
  },
  equals: {
    id: "ValueRangeFilter_equals",
    defaultMessage: "equals"
  },
  between: {
    id: "ValueRangeFilter_between",
    defaultMessage: "between"
  }
});
const options = [
  {
    value: "less",
    label: localized.less,
    startIcon: CustomIcon.LessThan
  },
  {
    value: "greater",
    label: localized.greater,
    startIcon: CustomIcon.GreaterThan
  },
  {
    value: "equals",
    label: localized.equals,
    startIcon: CustomIcon.Equals
  },
  {
    value: "between",
    label: localized.between,
    startIcon: CustomIcon.Between
  }
];
function OperatorSelectInner({ value, onChange, key, fieldState, hideEqualOperator }) {
  const selectOptions = hideEqualOperator ? options?.filter((o) => o.value !== "equals") : options;
  return /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(
    FormSelect,
    {
      key,
      value,
      onChange,
      options: selectOptions,
      fieldState,
      isCompareOptionsAvailable: false
    }
  )));
}
const OperatorSelect = withLabel(OperatorSelectInner);
export {
  OperatorSelect,
  OperatorSelectInner
};
//# sourceMappingURL=OperatorSelect.js.map
